import React from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import NProgress from 'nprogress'
import { Helmet } from 'react-helmet'
// import Loader from 'components/cleanui/layout/Loader'
import PublicLayout from './Public'
import AuthLayout from './Auth'
import MainLayout from './Main'
import MailLayout from './Mail'
import OnBoardingLayout from './OnBoarding'

const Layouts = {
  public: PublicLayout,
  auth: AuthLayout,
  main: MainLayout,
  mail: MailLayout,
  onboarding: OnBoardingLayout,
}

const mapStateToProps = ({ user }) => ({ user })
let previousPath = ''

const Layout = ({ user, children, location: { pathname, search } }) => {
  // NProgress & ScrollTop Management
  const currentPath = pathname + search
  if (currentPath !== previousPath) {
    window.scrollTo(0, 0)
    NProgress.start()
  }
  setTimeout(() => {
    NProgress.done()
    previousPath = currentPath
  }, 300)

  // Layout Rendering
  const getLayout = () => {
    if (pathname === '/') {
      return 'public'
    }
    if (/^\/auth(?=\/|$)/i.test(pathname)) {
      return 'auth'
    }
    if (/^\/onboarding(?=\/|$)/i.test(pathname)) {
      return 'onboarding'
    }
    if (/^\/mail(?=\/|$)/i.test(pathname)) {
      return 'mail'
    }
    return 'main'
  }

  const Container = Layouts[getLayout()]
  const isUserAuthorized = user.authorized
  const isUserLoading = user.loading
  const isOnBoardingDone = user.onBoardingDone
  const isAuthLayout = getLayout() === 'auth'
  const isMailLayout = getLayout() === 'mail'
  const isOnBoardingLayout = getLayout() === 'onboarding'

  const BootstrappedLayout = () => {
    // show loader when user in check authorization process, not authorized yet and not on login pages
    if (isUserLoading && !isUserAuthorized && !isAuthLayout) {
      return null
    }
    // redirect to login page if current is not login page and user not authorized
    if (!isAuthLayout && !isUserAuthorized && !isMailLayout) {
      return <Redirect to="/auth/login" />
    }
    if (isUserAuthorized && !isOnBoardingDone && !isOnBoardingLayout && !isMailLayout) {
      return <Redirect to="/onboarding" />
    }
    // in other case render previously set layout
    return <Container>{children}</Container>
  }

  return (
    <>
      <Helmet titleTemplate="Mobidoc %s" title="App" />
      {BootstrappedLayout()}
    </>
  )
}

export default withRouter(connect(mapStateToProps)(Layout))
